import { theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { ContainerProps } from './Container.types';

export const Root = styled.main<StyledMods<Pick<ContainerProps, 'height'>>>`
    width: ${theme.container.content.large};
    height: ${({ $height }) => $height};
    margin-left: auto;
    margin-right: auto;

    @media (max-width: ${theme.container.breakpoint.large}) {
        width: ${theme.container.content.medium};
    }

    @media (max-width: ${theme.container.breakpoint.medium}) {
        width: ${theme.container.content.small};
    }

    @media (max-width: ${theme.container.breakpoint.small}) {
        width: ${theme.container.content.xsmall};
    }

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: ${theme.container.content.xxsmall};
    }
`;
